import { Button } from "@/components/ui/button"
import { useNavigate } from "react-router-dom"
import { motion } from "framer-motion"
import { Home } from "lucide-react"

const Error = () => {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gradient-to-b from-primary/5 to-white flex items-center justify-center p-4 safe-top safe-bottom">
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="glass p-8 md:p-12 rounded-3xl shadow-xl max-w-lg w-full mx-auto text-center relative"
      >
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          <h1 className="text-7xl md:text-8xl font-bold text-primary/20 mb-6">404</h1>
          <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4">
            Página não encontrada
          </h2>
          <p className="text-gray-600 mb-8">
            Desculpe, a página que você está procurando não existe ou foi movida.
          </p>
          <Button
            onClick={() => navigate("/")}
            className="gap-2 shadow-lg hover:shadow-primary/20 transition-all duration-300"
          >
            <Home className="w-4 h-4" />
            Voltar para o início
          </Button>
        </motion.div>
      </motion.div>
    </div>
  )
}

export default Error